import { NotificationDropdown } from '@/components/layout/NotificationDropdown';
import { useDashboardData } from '@/contexts/DashboardDataContext';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  showBackButton?: boolean;
  onBack?: () => void;
}

/**
 * ✅ PHASE 1B : PageHeader consomme le context depuis AppLayoutWithHeader
 * 
 * Le Provider est dans AppLayoutWithHeader, donc PageHeader a toujours accès au context
 * Pas besoin de version "optionnelle" car toutes les pages avec ce header ont le Provider
 */
export const PageHeader = ({ title, showBackButton = false, onBack }: PageHeaderProps) => {
  // ✅ PHASE 1B: Consommer depuis le context (Provider dans AppLayoutWithHeader)
  const { notifications, unreadCount, markNotificationAsRead, markAllNotificationsAsRead } = useDashboardData();
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="app-page-container flex flex-col gap-1.5 border-b border-[hsl(var(--app-border-subtle))] pb-2.5 md:flex-row md:items-center md:justify-between">
      <div className="flex items-start gap-2">
        {showBackButton && (
          <button
            onClick={handleBack}
            className="mt-0.5 flex h-7.5 w-7.5 items-center justify-center rounded-lg border border-[hsl(var(--app-border-subtle))] bg-white text-[hsl(var(--app-text-muted))] transition-colors hover:text-[hsl(var(--app-text-strong))]"
            title="Retour"
          >
            <ArrowLeft className="h-4.5 w-4.5" />
          </button>
        )}
        <div className="min-w-0">
          <h1 className="text-[18px] font-semibold leading-tight tracking-[-0.03em] text-[hsl(var(--app-text-strong))] md:text-[20px]">
            {title}
          </h1>
        </div>
      </div>
      
      {/* Notification */}
      <div className="inline-flex items-center gap-2 self-end md:self-center">
        <NotificationDropdown
          notifications={notifications}
          unreadCount={unreadCount}
          onMarkAsRead={markNotificationAsRead}
          onMarkAllAsRead={markAllNotificationsAsRead}
          hasUnread={unreadCount > 0}
        />
      </div>
    </div>
  );
};
